import React from 'react'
import {Iap, Iog} from '../../backend/model'
import {IapLink, IogLink} from '../TableItemLink'
import {compareNumericString} from '../../utils/sorting'

interface MetadataColumDefinition {
    id: string,
    header: string,
    cell: (value: any) => JSX.Element | string
    sortingComparator?: (a: any, b: any) => number | undefined
}

export const IOG_METADATA_COLUMN_DEFINITIONS: MetadataColumDefinition[] = [
    {
        id: 'iogId',
        header: 'IOG',
        cell: (iog: Iog): JSX.Element => <IogLink iogId={iog.iogId}/>,
        sortingComparator: (a: Iog, b: Iog): number => compareNumericString(a.iogId, b.iogId),
    },
]

export const IAP_METADATA_COLUMN_DEFINITIONS: MetadataColumDefinition[] = [
    {
        id: 'iapId',
        header: 'IAP',
        cell: (iap: Iap): JSX.Element => <IapLink iapId={iap.iapId}/>,
        sortingComparator: (a: Iap, b: Iap): number => compareNumericString(a.iapId, b.iapId),
    },
]
